let currentPage = 2;
let isLoading = false;
let noMoreProductsShown = false;

// ===== Infinite Scroll =====
window.addEventListener('scroll', () => {
  const lastProduct = document.querySelector('#product-grid .grid__item:last-child');
  if (!lastProduct || isLoading || noMoreProductsShown) return;

  const rect = lastProduct.getBoundingClientRect();
  if (rect.bottom <= window.innerHeight + 20) {
    triggerLoadMore();
  }
});

// ===== Trigger Loader =====
function triggerLoadMore() {
  if (isLoading || noMoreProductsShown) return;
  isLoading = true;

  const loader = document.getElementById('loading-indicator');
  loader.style.display = 'block';

  loadMoreProducts(); // Load next page
}

// ===== Product Loader =====
function loadMoreProducts(callback) {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.set('page', currentPage);
  const fullUrl = `${window.location.pathname}?${urlParams.toString()}`;

  fetch(fullUrl)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newItems = doc.querySelectorAll('#product-grid .grid__item');
      const productGrid = document.getElementById('product-grid');

      if (newItems.length > 0) {
        newItems.forEach(item => productGrid.appendChild(item));

        if (typeof initVariantAndCartHandlers === 'function') {
          initVariantAndCartHandlers();
        }

        applyCombinedFilters();
        currentPage++;
        isLoading = false;

        if (callback) callback();
        else setTimeout(triggerLoadMore, 500);
      } else {
        document.getElementById('loading-indicator').style.display = 'none';
        const noMore = document.getElementById('no-more-products');
        if (noMore) noMore.style.display = 'block';
        noMoreProductsShown = true;
      }
    })
    .catch(error => {
      console.error('Error loading more products:', error);
      isLoading = false;
      document.getElementById('loading-indicator').style.display = 'none';
    });
}

// ===== Combined Filter (Tags + Price) =====
function applyCombinedFilters() {
  const selectedTags = Array.from(document.querySelectorAll('input[type="checkbox"]:checked')).map(i => i.value.trim());

  // Handle both desktop and mobile price inputs
  const minInput = document.querySelector('.min-price-display') || document.querySelector('.min-price');
  const maxInput = document.querySelector('.max-price-display') || document.querySelector('.max-price');

  // Default values
  const minVal = parseInt(minInput?.value || "0");
  const maxVal = maxInput?.value ? parseInt(maxInput.value) : Infinity; // ✅ Infinite max if blank

  const products = document.querySelectorAll('#product-grid .grid__item');
  const filterTagsContainer = document.getElementById('FilterTags');
  const appliedFiltersBox = document.getElementById('AppliedFilters');

  filterTagsContainer.innerHTML = '';
  selectedTags.forEach(tag => {
    const tagEl = document.createElement('span');
    tagEl.textContent = tag;
    tagEl.style = "background:#eee; padding:4px 10px; margin:4px; display:inline-block; border-radius:4px;";
    filterTagsContainer.appendChild(tagEl);
  });
  appliedFiltersBox.style.display = selectedTags.length > 0 ? 'block' : 'none';

  products.forEach(p => {
    const productTags = p.getAttribute('data-tags')?.split(',').map(t => t.trim()) || [];
    const price = parseInt(p.getAttribute('data-price') || '0');

    const tagMatch = selectedTags.length === 0 || selectedTags.every(t => productTags.includes(t));
    const priceMatch = price >= minVal && price <= maxVal;

    p.style.display = (tagMatch && priceMatch) ? '' : 'none';
  });
}

// ===== Checkbox Filters (Tag Filters) =====
document.querySelectorAll('input[type="checkbox"]').forEach(input => {
  input.addEventListener('change', () => {
    currentPage = 2;
    noMoreProductsShown = false;
    applyCombinedFilters();
    triggerLoadMore();
  });
});

// ===== Price Filters (Auto Loads All Pages) =====
document.querySelectorAll('.min-price, .max-price, .min-price-display, .max-price-display').forEach(input => {
  input.addEventListener('change', () => {
    const loader = document.getElementById('loading-indicator');
    loader.style.display = 'block';

    currentPage = 2;
    noMoreProductsShown = false;

    // Clear previously loaded products
    const productGrid = document.getElementById('product-grid');
    productGrid.innerHTML = '';

    // Recursive loader to fetch all pages
    function loadAllPages() {
      loadMoreProducts(() => {
        if (!noMoreProductsShown) loadAllPages();
        else {
          applyCombinedFilters();
          loader.style.display = 'none';
        }
      });
    }

    // Start immediately (no scroll needed)
    isLoading = false;
    loadAllPages();
  });
});
